"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDebuffs = void 0;
function applyDebuffs(args) {
    const { attackerId, targetId, effects = [], onApplied, onResisted, onAppliedOrResisted, hidden } = args;
    if (effects.length === 0) {
        return [];
    }
    const debuffSequences = args.sequence.pushSequence("parallel");
    const appliedEffects = [];
    const resistedEffects = [];
    const effectIds = effects.map((debuff) => {
        return this.applyDebuff({
            attackerId,
            targetId,
            ...debuff,
            hidden,
            sequence: debuffSequences,
            onApplied(sequence, args) {
                var _a, _b;
                appliedEffects.push(args);
                (_a = debuff.onApplied) === null || _a === void 0 ? void 0 : _a.call(debuff, sequence, args);
                (_b = debuff.onAppliedOrResisted) === null || _b === void 0 ? void 0 : _b.call(debuff, sequence, args, true);
            },
            onResisted(sequence, args) {
                var _a, _b;
                resistedEffects.push(args);
                (_a = debuff.onResisted) === null || _a === void 0 ? void 0 : _a.call(debuff, sequence, args);
                (_b = debuff.onAppliedOrResisted) === null || _b === void 0 ? void 0 : _b.call(debuff, sequence, args, false);
            },
        });
    });
    if (appliedEffects.length > 0) {
        onApplied === null || onApplied === void 0 ? void 0 : onApplied(debuffSequences, appliedEffects);
        onAppliedOrResisted === null || onAppliedOrResisted === void 0 ? void 0 : onAppliedOrResisted(debuffSequences, appliedEffects, true);
    }
    if (resistedEffects.length > 0) {
        onResisted === null || onResisted === void 0 ? void 0 : onResisted(debuffSequences, resistedEffects);
        onAppliedOrResisted === null || onAppliedOrResisted === void 0 ? void 0 : onAppliedOrResisted(debuffSequences, resistedEffects, false);
    }
    return effectIds;
}
exports.applyDebuffs = applyDebuffs;
